/* eslint-disable react/react-in-jsx-scope */
import { Tooltip, Menu, Dropdown } from 'antd';
import styles from "./callsEditShareTrans.module.scss";
import { URButton } from '../../../../shared/widgets/button';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // ES6
import {
  backToMainPage, callActionChanges,
  currentTimer,
  PDfSharenDownload, wordSharenDownnload
} from '../../../../base/callService/common';
import _ from 'lodash';
import store from '../../../../context/store/store';
import { Types } from '../../../../context/action/action';
import React from 'react';

type CallsEditShareTransProps = {
  gotoMainPage?: any;
  transcriptionDetails?: any;
  commonDetail?: any;
  title?: any;
}
export default function CallsEditShareTrans({ gotoMainPage, commonDetail, transcriptionDetails, title }:
  CallsEditShareTransProps) {

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      // [{size: []}],
      ['bold', 'italic', 'strike', 'blockquote','link'],
      [{ list: 'ordered' }, { list: 'bullet' }]
    ]
  };

  // const modules1 = {
  //   toolbar: {
  //     container: [
  //       ["bold", "italic", "underline", "strike"],
  //       [
  //         { list: "ordered" },
  //         { list: "bullet" },
  //         { align: "right" }
  //       ],
  //       ["link", "image"]

  //     ]
  //   },
  //   clipboard: { matchVisual: false }
  // };

  const formats = [
    "bold",
    "italic",
    "strike",
    "blockquote",
    "size",
    "list",
    "bullet",
    "link",
    "image",
    "align",
    "color",
    "background"
  ];

  const handleChange =  _.debounce((content:any, delta:any, source:any, editor:any) => {


    /****** need to check **********/

    // const getHTML = editor.getHTML();
    // let text = getHTML;
    // let split_Text = text.replace(/<\/li>/gi, " || ");
    // text = split_Text.replace(/<[^>]+>/g, '');
    //StoreEditAutomatedMinutes(text);
    //setScriptInfo({ ...scriptInfo, editautomated: text});
    
  }, 1000);



  // let transcriptionDetails = store.getState().closeCaption || [];
  // console.log("transcriptionDetails", transcriptionDetails);
  // let data: any = [];
  // if (transcriptionDetails.asrCallingFrom === 'callList') {
  //   data = transcriptionDetails.editautomatedmins || [];
  // }
  // else { data = transcriptionDetails.voiceTranscript || []; }
  // //console.log("transcriptionDetails is",transcriptionDetails);
  const goNext = () => {
    callActionChanges('summaryShare')
    let editedDiv :any= document.getElementById("editor")?.innerHTML;
    store.dispatch({
      type: Types.DIV_EDITOR,
      payload: {
        quilDiv: editedDiv
      }
    })
  }
  return (
    <>
      <div className={styles.chatDialPadContainer}>
        <div className={styles.chatsharefile}>
          <div className={styles.topHeaderShareSec} onClick={gotoMainPage}>
            <h4><span className="icon_searchlft"></span> Edit & Share Transcription</h4>
          </div>
          <div className={styles.topinnerSecCon}>
            <div className={styles.downloadHeadSec}>
              <h3>{commonDetail?.caller_id} - {title}  <span>{(commonDetail?.time) ? (commonDetail?.time) :
                currentTimer().date +' '+ currentTimer().month +
                ' '+ currentTimer().year}</span></h3>
              <Tooltip placement="topRight" title="Download">
                <Dropdown placement="bottomRight" className={styles.callsSummaryBtn}
                  overlay={
                    <Menu>
                      <Menu.Item>
                        <a  onClick={()=>PDfSharenDownload(true,document.getElementById("editor")?.innerHTML)}>Pdf</a>
                      </Menu.Item>
                      <Menu.Item>
                        <a onClick={()=>wordSharenDownnload(true,document.getElementById("editor")?.innerHTML)}>Word</a>
                      </Menu.Item>
                    </Menu>
                  } trigger={['click']}>
                  <label className="icon_Downloadstroke"></label>
                </Dropdown>
              </Tooltip>
            </div>
            <div className={styles.notestopbarsec}>
              {/* <ReactQuill theme="snow" className="CustomHeightSet"></ReactQuill> */}
              <ReactQuill
                placeholder={'Enter description'}
                formats={formats}
                modules={modules}
                theme="snow"
                readOnly={false}
                onChange={(content:any, delta:any, source:any, editor:any)=>
                  handleChange(content, delta, source, editor)}
              >
                <div id="editor">
                  {transcriptionDetails && transcriptionDetails.map((elem: any, index: any) => {
                    return (<>
                      <div>{elem.text}</div>
                      {/* <Highlights searchWords={''}>{elem.text}</Highlights> */}
                    </>);
                  })}
                </div>
              </ReactQuill>
            </div>
          </div>
          <div className={styles.chatfooterbtn}>
            <URButton className={styles.chatcancelbtn} name='Cancel' onClick={backToMainPage}/>
            <URButton className={styles.chatSharebtn} name='Next' onClick={goNext} />
          </div>
        </div>
      </div>
    </>
  );
};

